import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {config} from "@alpha/services";

@Component({
  selector: 'tracking-link',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tracking-link.component.html',
  styleUrls: ['./tracking-link.component.scss']
})
export class TrackingLinkComponent {

  @Input() values: string = "";
  @Input() label: string = "AWN/BOL #";
  @Input() data: any= undefined;
  click(){
    let link = '#';
    if (this.data.courier_type == 1) {
      link = "https://connect.track-trace.com/for/" + config.trackingID + "/aircargo/" + this.values;
    }
    if (this.data.courier_type == 0) {
      link = "https://connect.track-trace.com/for/" + config.trackingID + "/billoflading/" + this.values;
    }
    window.open(link, '_blank');
  }
}
